import { useEffect, useState } from "react";

const useCacheImage = (imgUrl) => {
  const [imgBlob, setImgBlob] = useState(null);

  const fetchImage = async () => {
    const cache = await caches.open("image-cache");
    const cacheRequest = new Request(imgUrl);

    // 1. check cache first
    const cachedResponse = await cache.match(cacheRequest);
    if (cachedResponse) {
      const blob = await cachedResponse.blob();
      setImgBlob(URL.createObjectURL(blob));
      return;
    }

    // 2. if dont exist on cache → fetch from minio
    const response = await fetch(imgUrl, {
      mode: "cors", // quan trọng nếu MinIO khác domain
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.status}`);
    }

    // 3. store to cache
    const responseToCache = response.clone();
    await cache.put(cacheRequest, responseToCache);

    const blob = await response.blob();
    setImgBlob(URL.createObjectURL(blob));
  };

  useEffect(() => {
    fetchImage();
  }, [imgUrl]);

  return { imgBlob };
};

export { useCacheImage };
